import { defineStore } from "pinia";
import { ref } from "vue";
export const useCarViolationStore = defineStore("carViolationStore", () => {
    const carData = ref({
        view_mode: "all",
        plate_left: "",
    });
    const violationData = ref({});
    return {
        carData,
        violationData,
    };
}, {
    persist: true,
});
